import { selectUserProfileImageURL } from '../state/userSlice';
import { useSelector } from 'react-redux';

const useProfileImageURL = () => useSelector(selectUserProfileImageURL);

export default useProfileImageURL;
